import React from "react";

import { IconQuestionCircleOutlined } from "~/components/icon";
import { cx } from "~/tools/class-variance";

import { Button } from "../buttons/Button";
import { DocLink } from "../docLink/DocLink";
import { Markdown } from "../markdown/Markdown";

import { BaseTooltip, type TooltipPlacement } from "./BaseTooltip";

export interface HelpTooltipProps {
	content?: string;
	moreInfoPlaceholder?: React.ReactElement;
	placement?: TooltipPlacement;
	type?: "string" | "markdown";
	className?: string;
}

export const HelpPopupTooltip = ({
	content = "",
	moreInfoPlaceholder,
	placement,
	type,
	className,
}: HelpTooltipProps) => (
	<BaseTooltip
		placement={placement}
		title={
			<>
				{type && type === "markdown" ? (
					<Markdown className="prose-p:text-white prose-strong:text-white" openLinksInNewTab text={content} />
				) : (
					content
				)}{" "}
				{moreInfoPlaceholder}
			</>
		}
		trigger="click"
	>
		<Button
			className={cx("p-0", className)}
			data-testid="tooltip-button"
			onClick={(e) => e.stopPropagation()}
			size="small"
			type="link"
		>
			<IconQuestionCircleOutlined className="text-grey-600 [&_svg]:flex" />
		</Button>
	</BaseTooltip>
);

export const HelpPopupTooltipMoreInfoLink: React.FC<React.ComponentProps<typeof DocLink>> = ({
	className,
	...props
}) => (
	<DocLink
		{...props}
		className={cx("text-white underline visited:text-white hover:text-white hover:no-underline", className)}
	/>
);
